// extracted by mini-css-extract-plugin
module.exports = {"unitPrice":"UnitPrice_unitPrice__udR0o"};